import ExamAanmeldingen from "../views/schooladmin/ExamAanmeldingen";
import ExamAanmeldingenAddEdit from "../views/schooladmin/ExamAanmeldingenAddEdit";

export default [
	{
		path: "/schooladmin/exam_aanmeldingen",
		components: {
			content: ExamAanmeldingen
		}
	},
	{
		path: "/schooladmin/exam_aanmeldingen/add",
		components: {
			content: ExamAanmeldingenAddEdit
		}
	}
];
